// Standard API response wrapper (matches backend ApiResponse<T>)
export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message: string | null;
  timestamp: string;
}

// Paginated response (matches backend Page<T>)
export interface Page<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number; // Current page (0-indexed)
  first: boolean;
  last: boolean;
  empty: boolean;
}

// Pagination params for API requests
export interface PaginationParams {
  page?: number;
  size?: number;
  sort?: string;
}

// API Error structure
export interface ApiError {
  message: string;
  status: number;
  type:
    | "authentication"
    | "authorization"
    | "validation"
    | "not_found"
    | "rate_limit"
    | "server_error"
    | "unknown";
  code?: string;
  // Backend sends one message per field (Map<String,String>); some endpoints
  // send multiple. Normalize to string[] via getValidationErrors before use.
  details?: Record<string, string | string[]>;
}

// Type guard for API errors
export const isApiError = (error: unknown): error is ApiError => {
  return (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    "type" in error &&
    "message" in error
  );
};

// Sort direction
export type SortDirection = "asc" | "desc";

// Common filter params
export interface FilterParams {
  search?: string;
  sortBy?: string;
  sortDirection?: SortDirection;
}
